import { useQuery } from '@tanstack/react-query';
import { fetchHistoricalTrackingAggregates } from '../services/outreach/engagementAnalyticsService';
import type { EngagementTimeRange } from '../utils/engagementAnalytics';
import type { SesTrackingDailyAggregate } from '../services/outreach/types';

interface UseCampaignPerformanceTrendsOptions {
  enabled?: boolean;
}

// Query key factory for campaign performance trends
export const campaignPerformanceTrendsKeys = {
  all: ['campaign-performance-trends'] as const,
  campaign: (campaignId: string) =>
    [...campaignPerformanceTrendsKeys.all, campaignId] as const,
  campaignWithRange: (campaignId: string, timeRange: EngagementTimeRange) =>
    [...campaignPerformanceTrendsKeys.campaign(campaignId), timeRange] as const,
};

export const useCampaignPerformanceTrends = (
  campaignId: string,
  timeRange: EngagementTimeRange,
  options: UseCampaignPerformanceTrendsOptions = {}
) => {
  return useQuery<SesTrackingDailyAggregate[]>({
    queryKey: campaignPerformanceTrendsKeys.campaignWithRange(campaignId, timeRange),
    queryFn: () => fetchHistoricalTrackingAggregates(timeRange, campaignId),
    enabled: options.enabled !== false && !!campaignId,
    staleTime: 60 * 1000, // 1 minute
    gcTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
